import { ArrowDown } from "lucide-react";

const HERO_BG_URL =
    "https://static.prod-images.emergentagent.com/jobs/bd3207ef-ee5e-4d93-accc-3f9c77fbe4a8/images/e76b1e551c28fad5dd7f0ac71e040e387d2149a8525f1ea919310aaf9d4dde1e.png";

const SYSTEM_BRIEF = [
    { label: "Model", value: "lucy-2.5", accent: false },
    { label: "Transport", value: "WebRTC", accent: false },
    { label: "Input", value: "Webcam · 720p", accent: false },
    { label: "Control", value: "Text + Reference", accent: true },
];

const HeroCopy = ({ onStart, ctaLabel }) => (
    <div className="lg:col-span-8 reveal">
        <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-blaze" />
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">
                Live · v2.5 · SPCLIVE Realtime
            </span>
        </div>
        <h1 className="font-display font-bold uppercase text-white text-5xl sm:text-6xl lg:text-[88px] leading-[0.92] tracking-tight">
            Turn yourself <br />
            <span className="text-blaze">into anything</span>
            <br />
            in realtime.
        </h1>
        <p className="mt-8 max-w-2xl text-base sm:text-lg text-white/60 leading-relaxed">
            A live-broadcasting control room for realtime video model. Point
            your camera. Describe the look. Watch yourself transformed at 30 FPS with near-zero
            latency — no rendering, no waiting.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <button
                onClick={onStart}
                data-testid="hero-cta-button"
                className="group bg-blaze hover:bg-blazeHover text-white font-mono uppercase tracking-[0.2em] text-sm px-8 py-4 flex items-center justify-center gap-3 transition-all duration-200 active:scale-[0.98]"
            >
                <span className="w-2 h-2 bg-white live-pulse" />
                {ctaLabel}
                <ArrowDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
            </button>
            <div className="hidden sm:flex items-center gap-4 px-4 py-4 border border-white/10 font-mono text-[11px] uppercase tracking-[0.2em] text-white/50">
                <span>30 FPS</span>
                <span className="w-px h-3 bg-white/20" />
                <span>720p</span>
                <span className="w-px h-3 bg-white/20" />
                <span>~120ms latency</span>
            </div>
        </div>
    </div>
);

const SystemBrief = () => (
    <div className="lg:col-span-4 reveal" style={{ animationDelay: "0.15s" }}>
        <div className="border border-white/10 bg-surface p-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
                System Brief
            </div>
            <dl className="space-y-3 font-mono text-xs">
                {SYSTEM_BRIEF.map((row, i) => (
                    <div
                        key={row.label}
                        className={`flex justify-between ${
                            i < SYSTEM_BRIEF.length - 1 ? "border-b border-white/5 pb-2" : ""
                        }`}
                    >
                        <dt className="text-white/40 uppercase tracking-wider">{row.label}</dt>
                        <dd className={row.accent ? "text-blaze" : "text-white"}>{row.value}</dd>
                    </div>
                ))}
            </dl>
        </div>
    </div>
);

export default function Hero({ onStart, ctaLabel = "Enter the Studio" }) {
    return (
        <section
            className="relative overflow-hidden border-b border-white/10"
            data-testid="hero-section"
        >
            <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    backgroundImage: `url('${HERO_BG_URL}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    opacity: 0.15,
                }}
            />
            <div className="absolute -right-40 -top-40 w-[600px] h-[600px] rounded-full bg-blaze/10 blur-[120px] pointer-events-none" />

            <div className="relative max-w-[1600px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                    <HeroCopy onStart={onStart} ctaLabel={ctaLabel} />
                    <SystemBrief />
                </div>
            </div>
        </section>
    );
}
